import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { FormHelperText } from '@mui/material';
import { CheckboxComponent, NumberInput } from '@utriper/core-ui';
import UnitLinkFormFields from 'modules/Experience/components/UnitLinkFormFields';
import { Container, Label } from '../../styles';
import { useTranslation } from 'react-i18next';

const CapacityTab = ({ form }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_calendar.schedule_form.capacity_tab.${key}`);
    const { values } = useFormState();

    return (
        <React.Fragment>
            {/* Schedule Capacity */}
            <Container>
                <Label>{translate('capacity_label')}</Label>
                <Field id="capacity" name="capacity" component={NumberInput} placeholder={translate('capacity_placeholder')} disabled={values?.unlimited} />
                <FormHelperText>{translate('capacity_helper')}</FormHelperText>
            </Container>

            {/* Checkboxs */}
            <Container>
                {/* Unlimited Capacity */}
                <Field
                    id="unlimited"
                    name="unlimited"
                    type="checkbox"
                    // TODO: Remove this and use a decent checkbox component.
                    render={({ input }) => (
                        <CheckboxComponent
                            {...input}
                            labelComponent={translate('unlimited_label')}
                            checked={values?.unlimited}
                            onFieldChange={(checked) => {
                                form.change('unlimited', checked);
                            }}
                        />
                    )}
                />

                {/* Private Slot */}
                <Field
                    id="privateSlot"
                    name="privateSlot"
                    type="checkbox"
                    // TODO: Remove this and use a decent checkbox component.
                    render={({ input }) => (
                        <CheckboxComponent
                            {...input}
                            labelComponent={translate('private_slot_label')}
                            checked={values?.privateSlot}
                            onFieldChange={(checked) => {
                                form.change('privateSlot', checked);
                            }}
                        />
                    )}
                />
            </Container>

            {/* Units */}
            <Container>
                <Label>{translate('units_label')}</Label>
                <UnitLinkFormFields form={form} showCapacity />
                <FormHelperText>{translate('units_helper')}</FormHelperText>
            </Container>
        </React.Fragment>
    );
};

export default CapacityTab;
